import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  clearIncidentData,
  clearIncidentReport,
  clearNeedsTransportQuestions,
  clearReplacementRentalCar,
  FETCH_FORM_QUESTIONS,
  FETCH_FORM_QUESTIONS_ERROR,
  FETCH_FORM_QUESTIONS_SUCCESS,
  GET_PREFILLED_DATA,
  GET_PREFILLED_DATA_SUCCESS,
  LOAD_INCIDENT_REPORT_FORM,
  SAVE_FORM_TO_STATE,
  UPDATE_INCIDENT_REPORT_DETAILS,
  UPDATE_SERVICE_TYPE_OPTIONS,
  UPDATE_TOW_REASON,
} from "../action";
import {
  getIsTireDamaged,
  getServiceRequestEmail,
  getServiceFlatTirePart,
  getIncidentReportQuestions as selectIncidentReportQuestions,
  getIsServiceTow,
  getTowReason
} from "../selector";
import { getIncidentReportQuestions } from "../api";
import { datadogRum } from "@datadog/browser-rum";
import { formatDateAsString, formatTimeAsString } from "../utils/timeUtil";
import { ACCIDENT, TIRE_DAMAGE, TIRE_STANDARD_WITHOUT_SPARE, VANDALISM } from "../app-consts/appConstants";
export function* loadIncidentReportFormSaga() {
  yield put({ type: FETCH_FORM_QUESTIONS });
  yield put({ type: GET_PREFILLED_DATA });
}

const getTireChangeReason = (isTireDamaged: boolean) => isTireDamaged ? TIRE_DAMAGE : "tire_service"

export function* fetchIncidentReportFormQuestions() {
  try {
    const isTireDamaged = yield select(getIsTireDamaged)
    const tireChangeReason = getTireChangeReason(isTireDamaged)
    const isTow = yield select(getIsServiceTow)
    const towReasonId = yield select(getTowReason);
    let reason: string;

    if (isTow) {
      switch (towReasonId) {
        case ACCIDENT:
        case VANDALISM:
        case TIRE_DAMAGE:
        case TIRE_STANDARD_WITHOUT_SPARE:  
        case "abandoned":
        case "glass_damage":
          reason = towReasonId;
          break;
        default:
          return;
      }
    } else {
      reason = tireChangeReason;
    }

    const payload = yield call(getIncidentReportQuestions, reason);
    yield put({ type: FETCH_FORM_QUESTIONS_SUCCESS, payload });
  } catch (e) {
    datadogRum.addError("fetchIncidentReportFormQuestions Saga error", e);
    yield put({ type: FETCH_FORM_QUESTIONS_ERROR, payload: e });
  }
}

export function* getPrefilledDataSaga() {
  const email = yield select(getServiceRequestEmail);
  const part = yield select(getServiceFlatTirePart);
  const isTow = yield select(getIsServiceTow);
  if (isTow) {
    yield put({ type: GET_PREFILLED_DATA_SUCCESS, payload: {} });
    return;
  }
  const tirePart =
    part === "backLeft" || part === "backRight" ? "Back" : "Front";

  yield put({
    type: GET_PREFILLED_DATA_SUCCESS,
    payload: {
      4710: { name: "email", questionId: 4710, value: email },
      4687: { name: "part", questionId: 4687, value: tirePart },
      4683: { name: "howManyFlatTires", questionId: 4683, value: "One" },
      814: { name: "multipleTires", questionId: 814, value: "N" },
    },
  });
}

export function* saveFormToStateSaga(action) {
  let incidentQnAs = yield select(selectIncidentReportQuestions);
  const answers = action.payload;
  const data = incidentQnAs.map((question: { orderNumber: number; questionId: number; questionText: string; responseType: string; responseText: string}) => {
    let responseText: string;
    if (answers[question.questionId]) {
      const isYesOrNo = question.responseType === "radio_button";
      responseText = !isYesOrNo
        ? answers[question.questionId]
        : answers[question.questionId] == "Yes"
        ? "Y"
        : "N";
      if (question.questionId === 4687 || question.questionId === 4683) {
        responseText = answers[question.questionId].toLowerCase();
      }
      return { ...question, responseText };
    }
  });

  yield put({
    type: UPDATE_INCIDENT_REPORT_DETAILS,
    payload: {
      incidentTime: {
        date: formatDateAsString(),
        time: formatTimeAsString().split(" ")[0],
        meridiem: formatTimeAsString().split(" ")[1].toLowerCase(),
      },
      incidentDetails: data,
    },
  });
}

export function* watchIncidentReportFormQuestionsSaga() {
  yield takeEvery(LOAD_INCIDENT_REPORT_FORM, loadIncidentReportFormSaga);
  yield takeEvery(FETCH_FORM_QUESTIONS, fetchIncidentReportFormQuestions);
  yield takeEvery(GET_PREFILLED_DATA, getPrefilledDataSaga);
  yield takeEvery(SAVE_FORM_TO_STATE, saveFormToStateSaga);
  yield takeEvery(UPDATE_TOW_REASON, function*() {
    yield put(clearIncidentReport());
    yield put(clearIncidentData());
  });
  yield takeEvery(UPDATE_SERVICE_TYPE_OPTIONS, function*() {
    yield put(clearIncidentReport());
    yield put(clearIncidentData());
    yield put(clearReplacementRentalCar());
    yield put(clearNeedsTransportQuestions());
  });
}
